import {
  color,
  Flex,
  useColorMode,
  useIsDesktopView,
  Text,
  typography,
} from 'deepstash-ui';
import dynamic from 'next/dynamic';
import useAuth from 'providers/hooks/useAuth';
import useProfile from 'providers/hooks/useProfile';
import useSource from 'providers/hooks/useSource';
import React from 'react';
import CuratorsNote from 'src/components/cards/CuratorsNote';
import CuratorSection from 'src/components/metacontent/sections/CuratorSection';
import { SourceType } from 'types/enums';
import {
  GAP_SIZE_REM,
  getRemWidthFromColumns,
  getTintHex,
  slugify,
} from 'utils/global';
import SourceCardVerticalProgress from './SourceCardVerticalProgress';
import { VLADIMIR_USER_ID } from 'utils/constants';

const EditSourceButton = dynamic(() => import('./header/EditSourceButton'));

const SourceCardMetaContent: React.FC = () => {
  const isDesktopView = useIsDesktopView();
  const { colorMode } = useColorMode();
  const { isLoggedIn } = useAuth();
  const { profile } = useProfile();

  const { source } = useSource();

  const sourceHref = React.useMemo(() => {
    return source?.seo?.source
      ? `/book/${source.seo?.source?.id}/${slugify(source.seo.source.title)}`
      : '';
  }, [source]);

  if (!source) return null;

  const dividerLine = (
    <Flex height={2} bgColor={color[colorMode].underground} width={'100%'} />
  );

  const renderLinkToBookSource = () => {
    if (
      source.sourceType === SourceType.BOOK &&
      source.seo !== undefined &&
      source.seo !== null &&
      source.seo.source !== undefined &&
      source.seo.source !== null
    ) {
      return (
        <>
          {dividerLine}
          <Text
            {...typography.primaryTextFonts.large.regular}
            color={color[colorMode].textSecondary}
          >
            {'Curious about different takes? Check out our  '}
            <a
              href={sourceHref}
              style={{
                // textDecoration: 'none',
                color: color[colorMode].textSecondary,
                fontWeight: 'bold',
              }}
            >{`${source.title} Summary`}</a>
            {
              ' book page to explore multiple unique summaries written by Deepstash users.'
            }
          </Text>
        </>
      );
    }
    return null;
  };

  const curatorData = (
    <Flex
      w={{ base: '100%', md: getRemWidthFromColumns(4) }}
      flexDirection="column"
      gridGap={GAP_SIZE_REM}
    >
      <CuratorSection user={source.userData} />
      {source.context && (
        <CuratorsNote
          text={source.context}
          quoteColor={getTintHex({
            ogColor: source.imageColor,
            opacity: 0.5,
            colorScheme: colorMode,
          })}
          showLabel
        />
      )}
      {isLoggedIn &&
        (profile?.id === source.userData.id ||
          profile?.id === VLADIMIR_USER_ID) && <EditSourceButton />}
      {renderLinkToBookSource()}
    </Flex>
  );

  return isDesktopView ? (
    <Flex w={getRemWidthFromColumns(11)} justifyContent="space-between">
      <SourceCardVerticalProgress source={source} />
      {curatorData}
    </Flex>
  ) : (
    curatorData
  );
};

export default SourceCardMetaContent;
